import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { ResponsePregunta } from 'src/app/models/response_pregunta.model';
import { RespostaPregunta } from 'src/app/models/resposta_pregunta.model';
import { TaulaMestre } from 'src/app/models/taula_mestre';
import { Valoracio } from 'src/app/models/valoracio.model';
import { ModalService } from 'src/app/services/modal.service';
import { RumiService } from 'src/app/services/rumi.service';
import { UtilitatsService } from 'src/app/services/utilitats.service';

@Component({
  selector: 'app-valoracions-finals',
  templateUrl: './valoracions-finals.component.html'
})
export class ValoracionsFinalsComponent implements OnInit, OnDestroy {

  readonly VALORACIO_1_PREGUNTA_1_RESPOSTA_2 = '2';
  readonly VALORACIO_2_PREGUNTA_1_RESPOSTA_1 = '3';
  readonly VALORACIO_2_PREGUNTA_1_RESPOSTA_2 = '4';
  readonly VALORACIO_2_PREGUNTA_1_RESPOSTA_3 = '5';
  readonly VALORACIO_3_PREGUNTA_1_RESPOSTA_3 = '24';
  readonly RESPOSTA_ALTRES = 17;
  
  public valoracionsFinalsForm: FormGroup;
  public errors: Array<string> = [];
  
  public get valoracions(): Array<Valoracio>{
    return this.rumiService.valoracions;
  }

  constructor(
    public translate: TranslateService,
    private router: Router,
    private rumiService: RumiService,
    private _fb: FormBuilder,
    private utilService: UtilitatsService,
    public modal: ModalService
  ) { }

  ngOnInit() {
    this.rumiService.pestanyaActiva = this.router.url;
    this.initValoracionsFinalsForm();
  }

  ngOnDestroy(): void {
    this.sync();
  }

  goToNextStep() {
    this.utilService.showSpinner('Carregant dades...');
    this.validar();
    if(this.errors.length > 0){
      this.modal.open('errors');      
      this.utilService.hideSpinner();
    }else{
      this.sync();
      this.utilService.hideSpinner();
      this.router.navigate(['simulacio','altres-observacions']);
    }
  }

  goToPrevStep() {
    this.sync();
    this.router.navigate(['simulacio','apreciacio-gravetat']);
  }

	navigate(url: String){
	  this.router.navigate([url]);
	}  

  private initValoracionsFinalsForm() {
    this.valoracionsFinalsForm = this._fb.group({
      valoracionsFinals1: [this.rumiService.simulacio.valoracionsFinals1, []],
        observadorPregunta: [this.rumiService.simulacio.observadorPregunta.idsRespostes, []],            
      explicacionsPregunta: [this.rumiService.simulacio.explicacionsPregunta.idResposta, []],
        observacionsFinExplicacions: [this.rumiService.simulacio.explicacionsPregunta.idsRespostes, []],
        grauPregunta: [this.rumiService.simulacio.grauPregunta.idResposta, []],
        accionsPregunta: [this.rumiService.simulacio.accionsPregunta.idsRespostes, []],
        altresAccions: [this.rumiService.simulacio.altresAccions, []],
        collaboraPregunta: [this.rumiService.simulacio.collaboraPregunta.idResposta, []],
      vinclePregunta: [this.rumiService.simulacio.vinclePregunta.idResposta, []],
        vincle: [this.rumiService.simulacio.vincle, []],      
        coneixementPregunta: [this.rumiService.simulacio.coneixementPregunta.idResposta, []]
    });

    this.valoracionsFinalsForm.get('valoracionsFinals1').valueChanges.subscribe(value => {
      this.valoracionsFinalsForm.get('observadorPregunta').setValue('');
    });
    this.valoracionsFinalsForm.get('explicacionsPregunta').valueChanges.subscribe(value => {
      this.valoracionsFinalsForm.get('grauPregunta').setValue('');
      this.valoracionsFinalsForm.get('accionsPregunta').setValue('');
      this.valoracionsFinalsForm.get('collaboraPregunta').setValue('');
      this.valoracionsFinalsForm.get('altresAccions').setValue('');
      this.valoracionsFinalsForm.get('observacionsFinExplicacions').setValue('');
      if(value == this.VALORACIO_2_PREGUNTA_1_RESPOSTA_2){//Si es selecciona la opcio 'Encara no s'ha intentat contactar amb ells o no s'ha pogut', es fixen els valors dels 3 subapartats a 'No ho conec'
        this.valoracionsFinalsForm.get('grauPregunta').setValue(9);//No ho conec
        this.valoracionsFinalsForm.get('accionsPregunta').setValue([11]);//No ho conec
        this.valoracionsFinalsForm.get('collaboraPregunta').setValue(21);//No ho conec
      }
    });
    this.valoracionsFinalsForm.get('vinclePregunta').valueChanges.subscribe(value => {
      this.valoracionsFinalsForm.get('vincle').setValue('');
      this.valoracionsFinalsForm.get('coneixementPregunta').setValue('');
      if(value == this.VALORACIO_3_PREGUNTA_1_RESPOSTA_3){
        this.valoracionsFinalsForm.get('vincle').enable();
        this.valoracionsFinalsForm.get('coneixementPregunta').enable();
      }else {
        this.valoracionsFinalsForm.get('vincle').disable();
        this.valoracionsFinalsForm.get('coneixementPregunta').disable();
      }
    });

    if(this.valoracionsFinalsForm.get('vinclePregunta').value==this.VALORACIO_3_PREGUNTA_1_RESPOSTA_3){
      this.valoracionsFinalsForm.get('vincle').enable();
      this.valoracionsFinalsForm.get('coneixementPregunta').enable();
    }else{
      this.valoracionsFinalsForm.get('vincle').disable();
      this.valoracionsFinalsForm.get('coneixementPregunta').disable();
    }

    this.valoracionsFinalsForm.get('accionsPregunta').valueChanges.subscribe(value => {
      this.valoracionsFinalsForm.get('altresAccions').setValue('');
    });  
    
  }

  sync(){
    let idResposta;
    let idsRespostes;
    let idSubResposta;
    let idsSubRespostes;
    let resposta;

    if(this.rumiService.simulacio != null) {
      this.rumiService.simulacio.valoracionsFinals1 = this.valoracionsFinalsForm.get('valoracionsFinals1').value;
      this.rumiService.simulacio.altresAccions = this.valoracionsFinalsForm.get('altresAccions').value;
      this.rumiService.simulacio.vincle = this.valoracionsFinalsForm.get('vincle').value;

      //Valoracio 0
      this.rumiService.simulacio.observadorPregunta = new ResponsePregunta();
      this.rumiService.simulacio.observadorPregunta.id = this.valoracions[0].preguntes[0].id;
      this.rumiService.simulacio.observadorPregunta.descripcioPregunta = this.valoracions[0].preguntes[0].descripcio;
      this.rumiService.simulacio.observadorPregunta.tipusPregunta = this.valoracions[0].preguntes[0].tipusPregunta;

      idResposta = this.valoracionsFinalsForm.get('valoracionsFinals1').value;
      resposta = this.valoracions[0].preguntes[0].respostes.find(resposta=>resposta.id == idResposta);
      if(resposta != null){
        this.rumiService.simulacio.observadorPregunta.idResposta = resposta.id;
        this.rumiService.simulacio.observadorPregunta.descripcioResposta = resposta.descripcio;
        idsSubRespostes = this.valoracionsFinalsForm.get('observadorPregunta').value;
        if(idsSubRespostes != ''){
          this.rumiService.simulacio.observadorPregunta.idsRespostes = idsSubRespostes;
          let descripcioResposta = '';
          resposta.preguntesAdicionals.forEach(p=>{
            if(this.rumiService.simulacio.observadorPregunta.idsRespostes.includes(p.id)){
              if(descripcioResposta == ''){
                descripcioResposta += p.descripcio;
              }else{
                descripcioResposta += ', '+p.descripcio;
              }
            }
          });
          this.rumiService.simulacio.observadorPregunta.descripcioResposta += ': '+descripcioResposta; 
        }
      }

      //Valoracio 1
      this.rumiService.simulacio.explicacionsPregunta = new ResponsePregunta();
      this.rumiService.simulacio.explicacionsPregunta.id = this.valoracions[1].preguntes[0].id;
      this.rumiService.simulacio.explicacionsPregunta.descripcioPregunta = this.valoracions[1].preguntes[0].descripcio;
      this.rumiService.simulacio.explicacionsPregunta.tipusPregunta = this.valoracions[1].preguntes[0].tipusPregunta;
      
      idResposta = this.valoracionsFinalsForm.get('explicacionsPregunta').value;
      resposta = this.valoracions[1].preguntes[0].respostes.find(resposta=>resposta.id == idResposta);
      if(resposta != null){
        this.rumiService.simulacio.explicacionsPregunta.idResposta = resposta.id;
        this.rumiService.simulacio.explicacionsPregunta.descripcioResposta = resposta.descripcio;
        let idsSubRespostes = this.valoracionsFinalsForm.get('observacionsFinExplicacions').value;
        if(idsSubRespostes != ''){
          this.rumiService.simulacio.explicacionsPregunta.idsRespostes = idsSubRespostes;
          let descripcioResposta = '';
          resposta.preguntesAdicionals.forEach(p=>{
            if(this.rumiService.simulacio.explicacionsPregunta.idsRespostes.includes(p.id)){
              if(descripcioResposta == ''){
                descripcioResposta += p.descripcio;
              }else{
                descripcioResposta += ', '+p.descripcio;
              }
            }
          });
          this.rumiService.simulacio.explicacionsPregunta.descripcioResposta += ': '+descripcioResposta;          
        }
      }

      //Valoracio 2
      this.rumiService.simulacio.grauPregunta = new ResponsePregunta();
      this.rumiService.simulacio.grauPregunta.id = this.valoracions[2].preguntes[0].id;
      this.rumiService.simulacio.grauPregunta.descripcioPregunta = this.valoracions[2].preguntes[0].descripcio;
      this.rumiService.simulacio.grauPregunta.tipusPregunta = this.valoracions[2].preguntes[0].tipusPregunta;

      idResposta = this.valoracionsFinalsForm.get('grauPregunta').value;
      resposta = this.valoracions[2].preguntes[0].respostes.find(resposta=>resposta.id == idResposta);
      if(resposta != null){
        this.rumiService.simulacio.grauPregunta.idResposta = resposta.id;
        this.rumiService.simulacio.grauPregunta.descripcioResposta = resposta.descripcio;
      }

      //Valoracio 3
      this.rumiService.simulacio.accionsPregunta = new ResponsePregunta();
      this.rumiService.simulacio.accionsPregunta.id = this.valoracions[3].preguntes[0].id;
      this.rumiService.simulacio.accionsPregunta.descripcioPregunta = this.valoracions[3].preguntes[0].descripcio;
      this.rumiService.simulacio.accionsPregunta.tipusPregunta = this.valoracions[3].preguntes[0].tipusPregunta;

      idsRespostes = this.valoracionsFinalsForm.get('accionsPregunta').value;
      if(idsRespostes != ''){
        // this.rumiService.simulacio.accionsPregunta.idResposta = resposta;
        this.rumiService.simulacio.accionsPregunta.idsRespostes = idsRespostes;
        let descripcioResposta = '';
        this.valoracions[3].preguntes[0].respostes.forEach(resposta=>{
          if(this.rumiService.simulacio.accionsPregunta.idsRespostes.includes(resposta.id)){
            if(descripcioResposta == ''){
              descripcioResposta += resposta.descripcio;
            }else{
              descripcioResposta += ', '+resposta.descripcio;
            }
            if(resposta.id == this.RESPOSTA_ALTRES){
              descripcioResposta += ' ('+this.valoracionsFinalsForm.get('altresAccions').value+')';
            }
          }
        });
        this.rumiService.simulacio.accionsPregunta.descripcioResposta = descripcioResposta;
      }

      //Valoracio 4
      this.rumiService.simulacio.collaboraPregunta = new ResponsePregunta();
      this.rumiService.simulacio.collaboraPregunta.id = this.valoracions[4].preguntes[0].id;
      this.rumiService.simulacio.collaboraPregunta.descripcioPregunta = this.valoracions[4].preguntes[0].descripcio;
      this.rumiService.simulacio.collaboraPregunta.tipusPregunta = this.valoracions[4].preguntes[0].tipusPregunta;

      idResposta = this.valoracionsFinalsForm.get('collaboraPregunta').value;
      resposta = this.valoracions[4].preguntes[0].respostes.find(resposta=>resposta.id == idResposta);
      if(resposta != null){
        this.rumiService.simulacio.collaboraPregunta.idResposta = resposta.id;
        this.rumiService.simulacio.collaboraPregunta.descripcioResposta = resposta.descripcio;
      }

      //Valoracio 5
      this.rumiService.simulacio.vinclePregunta = new ResponsePregunta();
      this.rumiService.simulacio.vinclePregunta.id = this.valoracions[5].preguntes[0].id;
      this.rumiService.simulacio.vinclePregunta.descripcioPregunta = this.valoracions[5].preguntes[0].descripcio;
      this.rumiService.simulacio.vinclePregunta.tipusPregunta = this.valoracions[5].preguntes[0].tipusPregunta;

      idResposta = this.valoracionsFinalsForm.get('vinclePregunta').value;
      resposta = this.valoracions[5].preguntes[0].respostes.find(resposta=>resposta.id == idResposta);
      if(resposta != null){
        this.rumiService.simulacio.vinclePregunta.idResposta = resposta.id;
        this.rumiService.simulacio.vinclePregunta.descripcioResposta = resposta.descripcio;
        idSubResposta = this.valoracionsFinalsForm.get('vincle').value;
        if(idSubResposta != ''){
          this.rumiService.simulacio.vinclePregunta.idsRespostes = [idSubResposta];
          let subResposta: TaulaMestre = resposta.preguntesAdicionals.find(p=>p.id == idSubResposta);
          if(subResposta != null){
            this.rumiService.simulacio.vinclePregunta.descripcioResposta += ' '+subResposta.descripcio; 
          }
        }
      }

      //Valoracio 6
      this.rumiService.simulacio.coneixementPregunta = new ResponsePregunta();
      this.rumiService.simulacio.coneixementPregunta.id = this.valoracions[6].preguntes[0].id;
      this.rumiService.simulacio.coneixementPregunta.descripcioPregunta = this.valoracions[6].preguntes[0].descripcio;
      this.rumiService.simulacio.coneixementPregunta.tipusPregunta = this.valoracions[6].preguntes[0].tipusPregunta;

      idResposta = this.valoracionsFinalsForm.get('coneixementPregunta').value;
      resposta = this.valoracions[6].preguntes[0].respostes.find(resposta=>resposta.id == idResposta);
      if(resposta != null){
        this.rumiService.simulacio.coneixementPregunta.idResposta = resposta.id;
        this.rumiService.simulacio.coneixementPregunta.descripcioResposta = resposta.descripcio;
      }
    }
  }

  validar(){
    this.errors = [];

    if(this.valoracionsFinalsForm.get('valoracionsFinals1').value == ''){
      this.errors.push(this.valoracions[0].preguntes[0].descripcio+" És obligatori seleccionar una opció");
    }else if(this.valoracionsFinalsForm.get('valoracionsFinals1').value == this.VALORACIO_1_PREGUNTA_1_RESPOSTA_2 && this.valoracionsFinalsForm.get('observadorPregunta').value == ''){
      this.errors.push(this.valoracions[0].preguntes[0].respostes[1].descripcio+": És obligatori seleccionar una opció");
    }

    if(this.valoracionsFinalsForm.get('explicacionsPregunta').value == ''){
      this.errors.push(this.valoracions[1].preguntes[0].descripcio+" És obligatori seleccionar una opció");
    }else if(this.valoracionsFinalsForm.get('explicacionsPregunta').value == this.VALORACIO_2_PREGUNTA_1_RESPOSTA_1 || this.valoracionsFinalsForm.get('explicacionsPregunta').value == this.VALORACIO_2_PREGUNTA_1_RESPOSTA_3){
      if(this.valoracionsFinalsForm.get('explicacionsPregunta').value == this.VALORACIO_2_PREGUNTA_1_RESPOSTA_3 && this.valoracionsFinalsForm.get('observacionsFinExplicacions').value == ''){
        this.errors.push(this.valoracions[1].preguntes[0].respostes[2].descripcio+": És obligatori seleccionar almenys una opció");
      }
      if(this.valoracionsFinalsForm.get('grauPregunta').value == ''){
        this.errors.push(this.valoracions[2].preguntes[0].descripcio+" És obligatori seleccionar una opció");
      }
      if(this.valoracionsFinalsForm.get('accionsPregunta').value == ''){
        this.errors.push(this.valoracions[3].preguntes[0].descripcio+" És obligatori seleccionar una opció");
      }else if(this.valoracionsFinalsForm.get('accionsPregunta').value.includes(this.RESPOSTA_ALTRES) && this.valoracionsFinalsForm.get('altresAccions').value == ''){
        this.errors.push(this.valoracions[3].preguntes[0].descripcio+" En cas de marcar la opció 'Altres', és obligatori informar el camp 'Altres Accions'");
      }
        
      if(this.valoracionsFinalsForm.get('collaboraPregunta').value == ''){
        this.errors.push(this.valoracions[4].preguntes[0].descripcio+" És obligatori seleccionar una opció");
      }
    }

    if(this.valoracionsFinalsForm.get('vinclePregunta').value == ''){
      this.errors.push(this.valoracions[5].preguntes[0].descripcio+" És obligatori seleccionar una opció");
    }else if(this.valoracionsFinalsForm.get('vinclePregunta').value == this.VALORACIO_3_PREGUNTA_1_RESPOSTA_3){
      if(this.valoracionsFinalsForm.get('vincle').value == ''){
        this.errors.push(this.valoracions[5].preguntes[0].respostes[2].descripcio+" És obligatori seleccionar un valor.");
      }
      if(this.valoracionsFinalsForm.get('coneixementPregunta').value == ''){
        this.errors.push(this.valoracions[6].preguntes[0].descripcio+": És obligatori seleccionar una opció.");
      }
    }
  }

}
